import { render, staticRenderFns } from "./SBImmunizationsAddEdit.vue?vue&type=template&id=1b0724f9"
import script from "./SBImmunizationsAddEdit.vue?vue&type=script&lang=js"
export * from "./SBImmunizationsAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SBImmunizationsAddEdit.vue?vue&type=style&index=0&id=1b0724f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports